import React from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import { useAuth } from '../context/AuthContext';
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Links = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  return (
    <DashboardLayout>
      <div className="container max-w-6xl mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row gap-6 md:items-center md:justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold">My Links</h1>
            <p className="text-muted-foreground mt-1">
              Manage all your booking links in one place
            </p>
          </div>
          <Button size="lg" onClick={() => navigate('/create-booking-link')} className="gap-2">
            <PlusCircle className="h-5 w-5" />
            Create New Link
          </Button>
        </div>

        {user ? (
          <div className="bg-white rounded-lg border shadow-sm p-6 mb-6">
            <h2 className="text-xl font-semibold mb-4">Personal Booking Link</h2>
            <div className="p-4 border rounded-md mb-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium">{user.name}'s Calendar</h3>
                  <p className="text-sm text-muted-foreground">{user.personalLink}</p>
                </div>
                <Button variant="outline" size="sm" onClick={() => navigate('/share-link')}>
                  Share
                </Button>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              Create additional booking links with custom availability and settings using the "Create New Link" button.
            </p>
          </div>
        ) : (
          <div className="text-center p-8">
            <p>Loading your links...</p>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Links;
